<template>
  <div
    class="manager_box"
    v-loading="realname_loading"
    element-loading-text="客户分配中"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <!-- <el-select v-model="Pie_chart_value" placeholder="请选择" v-if='!jurisdiction && $cookies.get("auth_grade") == 100' @change="handleClick">
      <el-option :key="super_options.staff_id" :label="super_options.realname" :value="super_options.staff_id"></el-option>
      <el-option-group v-for="group in tableData1" :key="group.name" :label="group.name">
        <el-option v-for="item in group.value" :key="item.staff_id" :label="item.realname" :value="item.staff_id">
        </el-option>
      </el-option-group>
    </el-select>-->

    <div style="background: white; padding: 0 20px; padding-top: 12px">
      <el-cascader
        v-model="Pie_chart_value_fu"
        :options="tableData1"
        :props="{ label: 'realname', value: 'staff_id', children: 'value' }"
        @change="handleChange"
        v-if="!jurisdiction && $cookies.get('auth_grade') == 100"
      ></el-cascader>
      <el-select
        v-model="Pie_chart_value"
        placeholder="请选择"
        v-else-if="!jurisdiction && $cookies.get('auth_grade') == 30"
        @change="handleClick"
      >
        <el-option
          v-for="item in tableData1"
          :key="item.staff_id"
          :label="item.realname"
          :value="item.staff_id"
        ></el-option>
      </el-select>
      <el-select
        v-model="Pie_chart_value"
        placeholder="请选择"
        v-else-if="!jurisdiction && $cookies.get('auth_grade') == 80"
        @change="handleClick"
      >
        <el-option
          v-for="item in tableData1"
          :key="item.staff_id"
          :label="item.realname"
          :value="item.staff_id"
        ></el-option>
      </el-select>
    </div>
    <div>
      <div class="filter_box">
        <!-- <div>
          <el-input placeholder="请输入内容" v-model="search_name" class="input-with-select">
            <el-select
              v-model="search_value"
              slot="prepend"
              placeholder="请选择"
              style="width: 100px;"
            >
              <el-option
                v-for="(item,index) in options"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button slot="append" @click="search" icon="el-icon-search"></el-button>
          </el-input>
        </div>-->
        <div>
          <el-cascader
            v-model="region_value"
            :options="region_options"
            @change="handleChange1"
            style="margin-right: 20px; min-width: 150px"
          ></el-cascader>
          <el-input
            placeholder="请输入内容"
            @input="input_search"
            v-model="search_name"
            class="input-with-select"
            style="margin-right: 20px; width: 300px"
          >
            <el-select
              v-model="search_value"
              slot="prepend"
              placeholder="请选择"
              style="width: 100px"
              @change="option_input"
            >
              <el-option
                label="不限"
                value
                v-if="$cookies.get('agent_company_name') == null"
                >不限</el-option
              >
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-button slot="append" @click="button_search" icon="el-icon-search"></el-button> -->
          </el-input>
          <el-button @click="button_search" icon="el-icon-search" type="primary"
            >搜索</el-button
          >
        </div>

        <el-button
          style="margin-left: 20px"
          v-if="jurisdiction || current_id == Pie_chart_value"
          @click="release"
          >释放客户</el-button
        >
        <el-cascader
          style="margin-left: 20px"
          v-if="!jurisdiction"
          placeholder="客户分配"
          v-model="customer_assignment_id"
          :options="tableData1"
          :props="realname_props"
          @change="realname_change"
        ></el-cascader>
        <!-- <el-dropdown
          style="margin-left:20px;"
          split-button
          type="primary"
          @command="handleClick_DIS"
          @click="click_dis"
        >
          {{ customer_assignment }}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in tableData1_list"
              :key="item.staff_id"
              :command="{ name: item.realname, id: item.staff_id }"
              >{{ item.realname }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>-->
        <!-- <div class="block">
          <el-date-picker
            v-model="valueDate"
            type="daterange"
            @change="changedate"
            value-format= 'timestamp'
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>-->
        <div style="color: #aaa; flex: 1; text-align: right">
          可添加数量： {{ client_total_count }}
        </div>
      </div>
      <div class="tab_name">
        <div v-for="(item, index) in tab_name_list" :key="item.name">
          <el-tag
            v-if="item.value != ''"
            style="margin: 10px 20px"
            @close="close_tab(index)"
            closable
            type
            >{{ item.name }}：{{ item.value }}</el-tag
          >
        </div>
      </div>
    </div>

    <div class="main">
      <el-table
        v-loading="loading"
        :data="tableData"
        ref="multipleTable"
        tooltip-effect="dark"
        @select-all="select_all_table"
        @select="select_table"
        @sort-change="changeTableSort"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="客户姓名" min-width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="showTable(scope.row)">
              {{ scope.row.client_name }}
            </el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column label="性别"> <template slot-scope="scope">{{ scope.row.client_gender==1?'男':'女' }}</template></el-table-column> -->
        <el-table-column
          label="公司名称"
          prop="company_name"
          min-width="180"
        ></el-table-column>
        <el-table-column
          label="客户类别"
          sortable="custom"
          prop="client_sort"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="手机号"
          prop="client_phone"
          min-width="120"
        ></el-table-column>
        <el-table-column
          label="公司职位"
          prop="company_position"
          min-width="80"
        ></el-table-column>
        <el-table-column
          label="公司地址"
          prop="area"
          min-width="100"
        ></el-table-column>
        <!-- <el-table-column label="客户所属" prop="product_name"></el-table-column> -->
        <!-- <el-table-column label="沟通备注" prop="com_remarks"></el-table-column> -->
        <el-table-column
          label="下次跟进时间"
          sortable="custom"
          prop="next_follow_time"
          min-width="150"
        ></el-table-column>
        <el-table-column label="下次出访时间" min-width="150">
          <template slot-scope="scope">
            {{
              scope.row.visit_client_time != "0"
                ? scope.row.visit_client_time_str
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="跟进次数"
          sortable="custom"
          prop="follow_count"
          min-width="140"
        ></el-table-column>
        <el-table-column
          label="上次跟进人"
          prop="recently_staff_name"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="客户行业"
          prop="industry_name"
          min-width="120"
        ></el-table-column>
        <el-table-column label="流程状态" min-width="80">
          <template slot-scope="scope">
            <el-tag>
              {{
                scope.row.follow_status_name
                  ? scope.row.follow_status_name
                  : "新客户"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="微信号" prop="client_wx"></el-table-column> -->
        <el-table-column
          label="客户来源"
          prop="client_source"
          min-width="80"
        ></el-table-column>
        <el-table-column
          label="更新时间"
          prop="update_time"
          min-width="90"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <div>选中：{{ client_id_list.length }}</div>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="current_change"
          @size-change="pageSizeChange"
          :current-page.sync="cilent_Page"
          :page-size="pagesize"
          :total="sale_count"
        ></el-pagination>
        <div>
          当前页：{{ tableData.length }}&nbsp;总数：{{ total_index }}&nbsp;
        </div>
      </div>
      <el-drawer
        title="我是标题"
        size="800"
        :visible.sync="dialog"
        :with-header="false"
        :before-close="
          () => {
            this.city_cascader_focus();
            this.dialog = false;
          }
        "
      >
        <div class="detail_info">
          <div>
            <!-- title -->
            <div class="nav_title">
              <div>
                <i
                  @click="close"
                  class="iconfont iconLC_icon_close_fill_circle"
                ></i>
              </div>
              <div>{{ client_name }}</div>
            </div>

            <div class="rl_flex">
              <!-- 概况 -->
              <div class="nav_left">
                <!-- 跟进状态 -->
                <div>
                  <div class="status_box">
                    <!-- 字和点的位置 -->
                    <div class="status_iter">
                      <div
                        class="status_item"
                        v-for="(item, index) in status"
                        :key="index"
                      >
                        <div
                          class="title"
                          :class="index <= status_id ? 'status_color' : ''"
                          @click="status_deal(item.follow_status_id, index)"
                        >
                          {{ item.follow_status_name }}
                        </div>
                        <!-- <div class="dot"></div> -->
                      </div>
                    </div>
                    <div class="line_iter">
                      <div
                        class="cir_item"
                        v-for="(item, index) in status"
                        :key="index"
                      >
                        <div
                          :class="
                            index <= status_id ? 'iconduigoutianchong-' : ''
                          "
                          class="cir iconfont"
                          @click="status_deal(item.follow_status_id, index)"
                        ></div>

                        <div
                          class="line_item"
                          :class="index < status_id ? 'status_back' : ''"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 客户概况 -->
                <div class="half_fl">
                  <div
                    v-for="(item, index) in survey"
                    :key="index"
                    :style="{ white: item.input ? '80%' : '50%' }"
                  >
                    <div class="title">{{ item.title }}</div>
                    <div v-if="item.cont" class="cont">{{ item.cont }}</div>
                    <div
                      v-else-if="item.input == 'date'"
                      class="cont_date_picker"
                    >
                      <el-date-picker
                        @change="nextTime"
                        v-model="item.value"
                        type="datetime"
                        placeholder="请选择下次跟进时间"
                      ></el-date-picker>
                    </div>
                    <div
                      v-else-if="item.input == 'date_item'"
                      class="cont_date_picker"
                    >
                      <el-date-picker
                        @change="nextTime_visit"
                        v-model="item.value"
                        type="datetime"
                        placeholder="请选择出访时间"
                      ></el-date-picker>
                    </div>
                    <div class="cont contclass" v-else>
                      <el-select
                        @change="saleChange"
                        v-model="item.value"
                        placeholder="请选择客户类型"
                      >
                        <el-option
                          v-for="(item, index) in sale_class"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option> </el-select
                      >类
                    </div>
                  </div>
                </div>

                <!-- 客户总体概览 -->
                <div>
                  <div>
                    <div class="over_title">基本信息</div>
                    <div class="half_fl">
                      <div v-for="(item, index) in basic_info" :key="index">
                        <div class="title">{{ item.title }}</div>

                        <div v-if="item.select">
                          <el-select
                            @change="selectChange"
                            v-model="item.value"
                            placeholder="请选择活动区域"
                          >
                            <el-option
                              v-for="(item, index) in sex"
                              :key="index"
                              :label="item.title"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </div>

                        <!-- 未点击 在没有值是 显示点击输入  有值显示时显示值 -->
                        <div
                          class="cont"
                          v-else-if="item.isclick && item.input"
                        >
                          <el-input
                            focus
                            :placeholder="item.input"
                            v-model="item.value"
                            @blur="compile(item)"
                            type="text"
                          >
                            <i
                              @click="item.isclick = false"
                              slot="suffix"
                              class="el-input__icon el-icon-date"
                            ></i>
                          </el-input>
                        </div>
                        <div class="cont" v-else @click="item.isclick = true">
                          {{ item.value == null ? "点击输入" : item.value }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="over_title">详细信息</div>
                    <div class="half_fl">
                      <div v-for="(item, index) in detail_info" class="half_list" :key="index">
                        <div class="title">{{ item.title }}</div>

                        <!--输入框 -->
                        <div v-if="item.input == 'text'" class="cont">
                          <div v-if="item.isclick" class="cont">
                            <el-input
                              :placeholder="item.placeholder"
                              v-model="item.value"
                              @blur="compile(item)"
                              type="text"
                            />
                          </div>
                          <div v-else @click="item.isclick = true">
                            {{ item.value == null ? "点击输入" : item.value }}
                          </div>
                        </div>

                        <div v-else-if="item.input == 'multi'" class="cont">
                          <el-cascader
                            v-model="item.value"
                            :options="place_data"
                            :props="place_props"
                            @change="placeChanged"
                          ></el-cascader>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  跟进状态-->
              <div class="nav_right">
                <!-- <div class="record">跟进记录</div> -->
                <div class="btns">
                  <el-input
                    type="textarea"
                    v-model="change_list"
                    :rows="3"
                    placeholder="添加跟进记录"
                  />
                  <el-button
                    style="height: 30px"
                    @click="submit_list"
                    type="primary"
                    >提交</el-button
                  >
                </div>

                <div class="rec_box">
                  <div
                    class="item"
                    v-for="(item, index) in record"
                    :key="index"
                  >
                    <div class="item_flex">
                      <div class="com_name">
                        <i class="iconfont iconkehuguanli"></i>
                        {{ item.staff_name }}
                      </div>
                      <div class="item_grow">{{ item.create_time }}</div>
                    </div>
                    <div class="follow_detail">{{ item.follow_detail }}</div>
                    <!-- <div @click="del(item.follow_id,index)" class="follow_del">删除</div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { require } from "@/utils/http_request.js";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      jurisdiction: false,

      paging_up_and_down: "0",
      prop_name: "",

      tableData1: [],
      super_options: {},
      Pie_chart_value: "",
      Pie_chart_value_fu: [],
      current_id: "",

      customer_assignment: "客户分配",
      customer_assignment_id: "",
      realname_props: {
        label: "realname",
        value: "staff_id",
        children: "value",
      },
      status_id_dict: {},
      loading: true,
      currentPage: 0,
      cilent_Page: 0,
      sale_count: 0,
      pagesize: 15,
      options: [], //筛选列表
      tab_name_list: [
        { name: "客户名称", value: "" },
        { name: "公司名称", value: "" },
        { name: "客户来源", value: "" },
        { name: "手机号", value: "" },
        { name: "职位", value: "" },
        { name: "客户类别", value: "" },
        { name: "备注", value: "" },
        { name: "微信号", value: "" },
        { name: "地区详情", value: "" },
        { name: "客户所属", value: "" },
      ],
      search_value: "", //筛选选项
      place_data: [],
      client_name: "",
      change_list: "",

      sale_class: [
        {
          label: "A",
          value: "A",
        },
        {
          label: "B",
          value: "B",
        },
        {
          label: "C",
          value: "C",
        },
        {
          label: "D",
          value: "D",
        },
      ],
      survey: [
        {
          title: "所属人员",
          cont: "北京三门课科技有限公司",
        },
        {
          title: "客户类型",
          value: "",
          type: "select",
        },
        {
          title: "下次跟进时间",
          type: "next_follow_time",
          value: null,
          isclick: false,
          input: "date",
        },
        {
          title: "下次出访时间",
          type: "visit_client_time_str",
          value: null,
          isclick: false,
          input: "date_item",
        },
      ],
      status: [],
      status_id: 0,
      sex: [
        {
          title: "男",
          value: 1,
        },
        {
          title: "女",
          value: 2,
        },
      ],
      basic_info: [
        {
          type: "client_name",
          title: "姓名",
          input: "请输入姓名",
          value: null,
          isclick: false,
        },
        {
          type: "client_wx",
          title: "微信号",
          value: null,
          isclick: false,
          input: "请输入微信号",
        },
        {
          type: "client_phone",
          title: "电话",
          input: "请输入电话",
          value: null,
          isclick: false,
        },

        // {
        //   type: "client_gender",
        //   title: "性别",
        //   select: "sex",
        //   value: null,
        //   isclick: false
        // }
      ],

      detail_info: [
        {
          type: "client_source",
          title: "客户来源",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入客户来源",
        },
        {
          title: "公司名称",
          type: "company_name",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入公司名称",
        },
        {
          type: "area_id",
          title: "所在城市",
          value: null,
          isclick: false,
          input: "multi",
          options: "",
        },
        {
          title: "公司职位",
          type: "company_position",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入公司职位",
        },
        {
          title: "详细地址",
          type: "company_place_detail",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入详细地址",
        },

        {
          title: "备注",
          type: "com_remarks",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入备注",
        },
      ],
      dialog: false,
      formLabelWidth: "80px",
      place_props: {
        value: "province_code",
        label: "province_name",
        children: "children",
      },
      indus_props: {
        value: "industry_id",
        label: "name",
        children: "children",
      },
      industry_data: [],
      visible: false,
      search_name: "", //搜索字符串
      valueDate: "", //筛选时间
      tableData: [],
      client_total_count: 0,
      total_index: 0,
      dialogFormVisible: false, //创建弹框
      search_data: {},
      staff_id: "",
      client_id: "",

      change_list: "",
      record: [],
      show_client_id: "",
      client_id_list: [],

      region_value: [""],
      region_options: [
        {
          label: "不限",
          value: "",
        },
      ],
      realname_loading: false,
    };
  },
  methods: {
    city_cascader_focus() {
      if (this.$cookies.get("auth_grade") != null) {
        if (this.place_data[0].children[0].label != "不限") {
          this.place_data[0].children.unshift({
            label: "不限",
            value: this.place_data[0].value,
          });
        }
      }
    },
    //删除地址中的不限
    del_agent_place() {
      if (this.$cookies.get("auth_grade") != null) {
        console.log(this.place_data[0].children[0]);
        if (this.place_data[0].children[0].label == "不限") {
          this.place_data[0].children = this.place_data[0].children.filter(
            (item, index) => {
              return item.label != "不限";
            }
          );
        }
      }
    },
    handleClick(tab, event) {
      this.currentPage = 0;
      this.cilent_Page = 1;
      this.client_id_list = [];
      this.$cookies.set("staff_id", tab);
      this.search();
    },

    handleChange(e) {
      this.currentPage = 0;
      this.cilent_Page = 1;
      this.$cookies.set("staff_id", e);
      this.Pie_chart_value = e[e.length - 1];
      this.search();
    },

    handleChange1(value) {
      console.log(value);
    },

    changedate(e) {
      console.log();
      if (e == null) {
        this.valueDate = [];
      }
      this.search();
    },
    button_search() {
      this.currentPage = 0;
      this.cilent_Page = 1;
      this.search();
    },
    search() {
      this.loading = true;
      let obj = this.search_data;
      obj["page"] = this.currentPage;
      obj["staff_id"] = this.Pie_chart_value;
      let search_data = {};
      obj["search_data"] = search_data;
      if (this.valueDate.length > 0) {
        search_data["start_create_time"] = this.valueDate[0] / 1000;
        search_data["end_create_time"] = this.valueDate[1] / 1000;
      }
      // try {
      //   let search_key = this.options[this.search_value].type;
      //   let search_value = this.search_name;

      //   let search_data = {};
      //   search_data[search_key] = search_value;
      // } catch (e) {}
      this.tab_name_list.forEach((element, index) => {
        if (element.value != "") {
          search_data[this.options[index].type] = element.value;
        }
      });
      if (this.$cookies.get("agent_company_name") != null) {
        if (this.region_value[0] == this.region_value[1]) {
          this.region_value = [""];
        }
      }
      if (this.region_value[this.region_value.length - 1] != "") {
        search_data["company_place"] =
          this.region_value[this.region_value.length - 1];
      }

      if (this.prop_name != "") {
        if (this.prop_name == "next_follow_status") {
          search_data.next_follow_status = this.paging_up_and_down;
        } else if (this.prop_name == "client_sort") {
          search_data.client_sort_status = this.paging_up_and_down;
        } else if (this.prop_name == "follow_count") {
          search_data.follow_info = this.paging_up_and_down;
        }
      }

      if (!this.jurisdiction) {
        obj.staff_id = this.Pie_chart_value;
      }
      require("post", "/lufish_sale/v1/lufish_me_client/", obj).then((res) => {
        this.loading = false;
        if (!res.code) {
          this.sale_count = res.sale_client_count;
          if (res.data) {
            res.data.map((item) => {
              if (item.company_place_data.city_name) {
                // item.area = item.company_place_data.city_name + "-" + item.company_place_data.district_name;
                if (
                  item.company_place_data.city_name ==
                  item.company_place_data.province_name
                ) {
                  item.area =
                    item.company_place_data.city_name +
                    "-" +
                    item.company_place_data.district_name;
                } else {
                  item.area =
                    item.company_place_data.province_name +
                    "-" +
                    item.company_place_data.city_name +
                    "-" +
                    item.company_place_data.district_name;
                }
                item.area_id = [
                  item.company_place_data.province_code,
                  item.company_place_data.city_code,
                  item.company_place_data.district_code,
                ];
              } else {
                item.area = "";
                item.area_id = [0, 0, 0];
              }
            });
            if (this.dialog) {
              res.data.map((item) => {
                if (item.client_id == this.show_client_id) {
                  this.showTable(item);
                }
              });
            }
            this.client_total_count = res.client_total_count;
            this.total_index = res.sale_client_count;
            this.tableData = res.data;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    input_search(e) {
      if (this.search_value !== "") {
        this.tab_name_list[this.search_value].value = e;
      }
    },
    option_input(e) {
      if (e == "") {
        this.search_name = "";
        this.tab_name_list.forEach((item) => {
          item.value = "";
        });
        // console.log('内容')
      } else {
        this.search_name = this.tab_name_list[this.search_value].value;
      }
    },
    close_tab(e) {
      // 关闭Tab 标签
      this.tab_name_list[e].value = "";
    },

    pageSizeChange(e) {
      console.log(e);
    },

    current_change(e) {
      this.currentPage = e - 1;
      // this.cilent_Page = e;
      this.client_id_list = [];
      this.search();
    },

    status_deal(status, index) {
      this.status_id = index;

      let compile_obj = {};
      compile_obj["follow_status_id"] = status;
      this.compile_d(compile_obj);
    },
    showstatus() {
      require("post", "/lufish_sale/v1/lufish_follow_tags_list/", {}).then(
        (res) => {
          if (!res.code) {
            // 销售流程ID
            res.data.map((item, index) => {
              this.status_id_dict[item.follow_status_id] = index;
            });
            this.status = res.data;
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },

    close() {
      console.log("关闭");
      this.city_cascader_focus();
      this.dialog = false;
      this.search();
    },

    showTable(e) {
      console.log("aaaaa", e);
      if (this.$cookies.get("agent_company_name") != null) {
        if (this.place_data[0].children[0].label == "不限") {
          this.place_data[0].children = this.place_data[0].children.filter(
            (item, index) => {
              return index != 0;
            }
          );
        }
      }
      this.show_client_id = e.client_id;
      this.dialog = true;
      this.staff_id = e.staff_id;
      this.client_name = e.client_name;
      this.client_id = e.client_id;
      this.status_id = this.status_id_dict[e.follow_status_id] || 0;
      this.survey[1].value = e.client_sort;
      //循环数据将数据进行 验证带入值
      for (let i in e) {
        this.record = e.follow_data;
        this.detail_info.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              if (i == "area_id") {
                if (this.$cookies.get("agent_company_name") != null) {
                  console.log([e[i][1], e[i][2]]);
                  item.value = [e[i][1], e[i][2]];
                } else {
                  item.value = e[i];
                }
              } else {
                item.value = e[i];
              }
            } else {
              item.value = "";
            }
          }
        });

        this.basic_info.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              item.value = e[i];
            } else {
              item.value = "";
            }
          }
        });
        this.survey.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              if (e[i] == "1970-01-01") {
                item.value = "";
              } else {
                item.value = e[i];
              }
            } else {
              item.value = "";
            }
          }
        });
      }
      console.log(this.detail_info, this.basic_info, this.survey, this.record);
    },

    placeChanged(e) {
      let compile_obj = {};

      if (this.$cookies.get("agent_company_name") != null) {
        compile_obj["company_place"] = e[1];
      } else {
        compile_obj["company_place"] = e[2];
      }
      this.compile_d(compile_obj);
    },

    selectChange(e) {
      let compile_obj = {};
      compile_obj["client_gender"] = e;
      this.compile_d(compile_obj);
    },
    saleChange(e) {
      let compile_obj = {};
      compile_obj["client_sort"] = e;
      this.compile_d(compile_obj);
    },

    nextTime(e) {
      if (e == null) {
        let compile_obj = {};
        compile_obj["next_follow_time"] = 0;
        this.compile_d(compile_obj);
      } else {
        //获取当前秒时间戳，在除以1000
        let d = new Date();
        let time = e.getTime() / 1000;
        if (time < Math.floor(d.getTime() / 1000)) {
          this.$message({
            message: "选择的时间不能低于当前时间",
            type: "warning",
          });
          this.survey.forEach((item) => {
            if (item.input == "date") {
              item.value = d;
            }
          });
          return;
        }
        let compile_obj = {};
        compile_obj["next_follow_time"] = time;
        this.compile_d(compile_obj);
      }
    },
    nextTime_visit(e) {
      if (e == null) {
        let compile_obj = {};
        compile_obj["visit_client_time"] = 0;
        this.compile_d(compile_obj);
      } else {
        let time = e.getTime() / 1000;
        let compile_obj = {};
        compile_obj["visit_client_time"] = time;
        this.compile_d(compile_obj);
      }
    },

    compile(item) {
      item.isclick = false;
      let compile_obj = {};
      compile_obj[item.type] = item.value;
      this.compile_d(compile_obj);
    },

    compile_d(obj = {}) {
      console.log(obj);
      let follow_update = {
        label_code: "update",
        client_id: this.client_id,
        update_client: obj,
      };
      if (!this.jurisdiction) {
        follow_update.staff_id = this.Pie_chart_value;
      }
      require("post", "/lufish_sale/v1/lufish_sale_client/", follow_update).then(
        (res) => {
          if (!res.code) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.search();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },

    //删除
    del(id, index) {
      let obj = {
        label_code: "delete",
        follow_id: id,
      };
      if (!this.jurisdiction) {
        obj.staff_id = this.Pie_chart_value;
      }
      require("post", "/lufish_sale/v1/lufish_sale_follow/", obj).then(
        (res) => {
          if (!res.code) {
            console.log(res);
            this.$message({
              message: res.msg,
              type: "success",
            });
            let record = this.record;
            if (record[index].follow_id == id) {
              record.splice(index, 1);
              this.record = record;
            }
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },

    submit_list() {
      let obj = {
        label_code: "create",
        create_data: {
          client_id: this.client_id,
          follow_detail: this.change_list,
        },
      };

      if (!this.jurisdiction) {
        obj.staff_id = this.Pie_chart_value;
      }
      var new_change = this.change_list.replace(/\s*/g, "");

      console.log(new_change);

      if (new_change == "") {
        this.$message.error("请输入跟进内容");
      } else {
        require("post", "/lufish_sale/v1/lufish_sale_follow/", obj).then(
          (res) => {
            if (!res.code) {
              this.$message({
                message: res.msg,
                type: "success",
              });

              let record_obj = {
                staff_name: this.$cookies.get("realname"),
                follow_detail: this.change_list,
                create_time: this.getCurrentTime(),
              };

              this.record.unshift(record_obj);
              this.change_list = "";
            } else {
              this.$message.error(res.msg);
            }
          }
        );
      }
    },

    //获取
    getCurrentTime() {
      let date = new Date();
      let Y = date.getFullYear();
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours();
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

      date = Y + "-" + M + "-" + D + " " + hours + ":" + minutes;
      console.log(date); //2019-10-12 15:19:33
      return date;
    },
    lufish_user_list(e) {
      require("POST", "/lufish_user/v1/lufish_staff/", {}).then((res) => {
        if (!res.code) {
          this.tableData1 = [];
          this.super_options = {};

          this.tableData1 = res.data;
          this.current_id = res.data[0].staff_id;

          if (!this.$cookies.get("staff_id")) {
            this.$cookies.set("staff_id", res.data[0].staff_id);
            this.Pie_chart_value = res.data[0].staff_id;
            if (this.$cookies.get("auth_grade") == 100) {
              this.Pie_chart_value_fu[0] = res.data[0].staff_id;
            }
            this.search();
          } else {
            let staff_id_split = this.$cookies.get("staff_id").split(",");
            console.log("staff_id_split", staff_id_split);
            if (this.$cookies.get("auth_grade") == 30) {
              // this.current_id = staff_id_split[0]
              this.Pie_chart_value = staff_id_split[0];
            } else {
              // this.current_id = staff_id_split[staff_id_split.length-1]
              this.Pie_chart_value = staff_id_split[staff_id_split.length - 1];
              this.Pie_chart_value_fu = staff_id_split;
              console.log("Pie_chart_value", this.Pie_chart_value);
            }
            this.search();
          }
        } else {
          this.$message.error("职员列表获取失败");
        }
      });
    },

    release() {
      // 释放缓存
      if (this.client_id_list.length == 0) {
        this.$message({
          message: "请选择释放的客户",
          type: "warning",
        });
        return false;
      }
      require("POST", "/lufish_sale/v1/lufish_me_highseas/", {
        client_id_list: this.client_id_list,
      }).then((res) => {
        if (!res.code) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.search();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    select_all_table(e) {
      this.client_id_list = [];
      if (e.length > 0) {
        e.map((item) => {
          this.client_id_list.push(item.client_id);
        });
      }
    },
    select_table(e) {
      this.client_id_list = [];
      if (e.length > 0) {
        e.map((item) => {
          this.client_id_list.push(item.client_id);
        });
      }
    },

    // handleClick_DIS(e) {
    //   // 分配
    //   // console.log('当前要分配给的人', e)
    //   this.customer_assignment = e.name;
    //   this.customer_assignment_id = e.id;
    //   if (this.client_id_list.length == 0) {
    //     this.$message.error("请选择要分配的客户");
    //     return false;
    //   }
    //   console.log("分配内容", this.Pie_chart_value);
    //   let obj = {
    //     later_staff_id: e.id,
    //     client_id_list: this.client_id_list,
    //     is_allocation: 1,
    //     before_staff_id: this.Pie_chart_value
    //   };
    //   require("post", "/lufish_sale/v1/lufish_me_other/", obj).then(res => {
    //     if (!res.code) {
    //       this.$message({
    //         message: res.msg,
    //         type: "success"
    //       });
    //       this.search();
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    realname_change(val) {
      console.log(val);
      if (this.client_id_list.length == 0) {
        this.$message.error("请选择要分配的客户");
        return false;
      }
      if (val[val.length - 1] == "") {
        this.$message.error("请选择要分配给的职员");
        return false;
      }
      console.log("分配内容", this.Pie_chart_value);
      this.realname_loading = true;
      let obj = {
        later_staff_id: val[val.length - 1],
        client_id_list: this.client_id_list,
        is_allocation: 1,
        before_staff_id: this.Pie_chart_value,
      };
      require("post", "/lufish_sale/v1/lufish_me_other/", obj).then((res) => {
        if (!res.code) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.realname_loading = false;
          this.search();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // click_dis(e) {},
    changeTableSort(e) {
      this.client_id_list = [];
      this.currentPage = 0;
      this.cilent_Page = 1;
      if (e.prop == "next_follow_time") {
        this.prop_name = "next_follow_status";
        if (e.order == "ascending") {
          // 上升
          this.paging_up_and_down = 0;
          this.search();
        } else if (e.order == "descending") {
          // 下降
          this.paging_up_and_down = 1;
          this.search();
        } else {
          this.prop_name = "";
          this.paging_up_and_down = "";
          this.search();
        }
      } else if (e.prop == "client_sort") {
        this.prop_name = "client_sort";
        if (e.order == "ascending") {
          // 上升
          this.paging_up_and_down = 0;
          this.search();
        } else if (e.order == "descending") {
          // 下降
          this.paging_up_and_down = 1;
          this.search();
        } else {
          this.prop_name = "";
          this.paging_up_and_down = "";
          this.search();
        }
      } else if (e.prop == "follow_count") {
        this.prop_name = "follow_count";
        if (e.order == "ascending") {
          // 上升
          this.paging_up_and_down = 0;
          this.search();
        } else if (e.order == "descending") {
          // 下降
          this.paging_up_and_down = 1;
          this.search();
        } else {
          this.prop_name = "";
          this.paging_up_and_down = "";
          this.search();
        }
      }
    },
  },
  created() {
    if (this.$cookies.get("auth_grade") == 20) {
      this.jurisdiction = true;
      this.search();
    } else {
      this.lufish_user_list();
    }
    this.showstatus();
    let options = [
      "按客户名称",
      "按公司名称",
      "按客户来源",
      "按手机号",
      "按职位",
      "按客户类别",
      "按备注",
      "按微信号",
      "按地区详情",
    ];
    let search_data = [
      "client_name",
      "company_name",
      "client_source",
      "client_phone",
      "company_position",
      "client_sort",
      "com_remarks",
      "client_wx",
      "company_place_detail",
    ];
    let options_add = [];
    options.map((item, index) => {
      options_add.push({
        value: String(index),
        label: item,
        type: search_data[index],
      });
    });
    this.options = options_add;
    if (this.$cookies.get("agent_company_name") == null) {
      this.place_props = {
        value: "value",
        label: "label",
        children: "children",
      };
    } else {
      this.place_props = {
        value: "value",
        label: "label",
        children: "children",
      };
    }
  },

  mounted() {
    if (this.$cookies.get("agent_company_name") != null) {
      require("post", "/lufish_sale/v1/agent_city_json/", {}).then((res) => {
        console.log(res);
        this.region_options = res.data;
        this.place_data = res.data;
      });
    } else {
      require("post", "/commonality/v1/show_place_json/", {}).then((res) => {
        this.region_options = this.region_options.concat(res.data);
        this.place_data = res.data;
      });
    }
    axios.get("/static/json/industry.json").then((res) => {
      this.industry_data = res;
    });
  },
  computed: {
    tableData1_list: function () {
      let add = [];
      console.log("遍历前", this.tableData1);
      if (
        this.$cookies.get("auth_grade") == 30 ||
        this.$cookies.get("auth_grade") == 80
      ) {
        console.log("30权限");
        add = this.tableData1;
      } else if (this.$cookies.get("auth_grade") == 100) {
        console.log("100权限");
        this.tableData1.forEach((item, idnex) => {
          if (idnex != 0) {
            item.value.forEach((name, idx) => {
              add.push(name);
            });
          } else {
            add.push(item);
          }
        });
      }
      return add;
    },
  },
};
</script>

<style scoped>
.main {
  width: 100%;
  padding-bottom: 70px;
  margin: 10px 0px;
  background: #ffff;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(32, 32, 32, 0.08);
  min-height: 80vh;
  position: relative;
}

/* .add_box {
  height: 68px;
  padding: 16px;
  box-sizing: border-box;
}

.add .el-input {
  width: 50%;
} */

.filter_box {
  display: flex;
  /* justify-content: space-between; */
  /* width: calc(100% - 181px); */
  width: 100%;
  border-bottom: 1px solid #e4e9ed;
  background: #fff;
  padding: 12px 20px;
  box-sizing: border-box;
  align-items: center;
}

.block {
  flex-grow: 1;
  margin-left: 20px;
}

.detail_info,
.detail_info > div,
.nav_left,
.nav_right,
.rl_flex {
  height: 100%;
}

.detail_info {
  position: relative;
}
.record {
  margin-bottom: 10px;
}

.btns .el-button {
  float: right;
  margin-top: 5px;
}

.nav_title {
  padding: 16px 24px;
  border-bottom: 1px solid #e4e9ed;
  display: flex;
}

.iconLC_icon_close_fill_circle {
  font-size: 24px;
  color: #3d76f7;
  position: absolute;
  top: 6px;
  left: 2px;
  cursor: pointer;
}

.nav_title > div {
  margin-left: 12px;
}

.rl_flex {
  display: flex;
}

.nav_left {
  width: 684px;
  border-right: 1px solid #e4e9ed;
}
.nav_left > div {
  padding: 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e9ed;
}

.over_title {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  color: #333;
}

.half_fl {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.half_list:nth-child(1) .cont{
  line-height: 22px;
  display: flex;
  align-items: center;
}

.pagination {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.pagination div {
  color: #aaa;
  font-size: 15px;
}

.status_box {
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  border-radius: 16px;
  position: relative;
}

.status_iter {
  display: flex;
  justify-content: space-between;
}

.status_item {
  display: flex;
  justify-content: center;
}

.status_color {
  color: #3d76f7;
}

.cir.status_back,
.line_item.status_back {
  background: #3d76f7;
}
.cir_item {
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
}
.cir_item img {
  height: 24px;
  width: 24px;
}

.cir:hover,
.status_item .title:hover {
  cursor: pointer;
}
.line_iter {
  margin-top: 10px;
  background: #f5f6fa;
  line-height: 32px;
  height: 32px;
  overflow: hidden;
  width: 100%;
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
}

.line_item {
  position: absolute;
  height: 10px;
  width: 140px;
  background: #e5e7ee;
  left: 23px;
  top: 10px;
}

.cir {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: #e5e7ee;
  color: #3d76f7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.half_fl .title {
  width: 92px;
}

.half_fl .cont {
  color: #333;
  width: 200px;
  height: 32px;
  line-height: 32px;
}

.contclass {
  display: flex;
}

.contclass .el-select {
  width: 60px;
  margin-right: 10px;
}

.half_fl > div {
  align-items: center;
  display: flex;
  width: 50%;
  margin-bottom: 16px;
  font-size: 14px;
  color: #999;
}

.nav_left > div:last-child {
  border-bottom: none;
}

.nav_right {
  /* width: calc(100% - 684px); */
  width: 440px;
  padding: 16px;
  box-sizing: border-box;
  font-size: 14px;
}

.rec_box {
  /* border:1px red solid; */
  max-height: calc(100vh - 250px);
  margin-top: 60px;
  overflow-y: auto;
}

.rec_box::-webkit-scrollbar {
  width: 4px;
}
.rec_box::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
}

.rec_box .item {
  margin-top: 24px;
  font-size: 14px;
  line-height: 22px;
}

.rec_box .item_flex {
  display: flex;
  justify-content: space-between;
}

.com_name {
  color: #999;
  width: 35%;
}

.item_grow {
  color: #999;
}

.follow_detail {
  color: #333;
}

.follow_del {
  float: right;
  margin-top: -10px;
  cursor: pointer;
  color: #333;
}

.tab_name {
  display: flex;
  flex-wrap: wrap;
  min-height: 50px;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/client.vue